import React, {useContext} from 'react';
import {Box, Sheet, Skeleton, Stack, Typography} from '@mui/joy';
import FolderRounded from '@mui/icons-material/FolderRounded';
import LockRounded from '@mui/icons-material/LockRounded';
import {LayoutContext} from '../context';
import {needsClientProfile} from '../shared/clientSession';
import AuthModal from '../components/modals/AuthModal';
import HomeMediaFolder from './Folder';
import './clientMaterials.css';

// Only a decorative shell is mounted before login/profile completion. No file
// names, thumbnail URLs, folder metadata or download capabilities enter the DOM.
function LockedMaterials() {
  return <Box className="cm-page cm-locked-page" aria-hidden="true" inert="">
    <header className="cm-heading"><div>
      <Typography className="cm-eyebrow" level="body-sm">Личный кабинет Planium</Typography>
      <Typography component="h1" level="h2">Материалы события</Typography>
      <Typography level="body-sm" className="cm-subtitle">Файлы вашего обмера в одном месте</Typography>
    </div><span className="cm-private"><LockRounded/>Защищённый доступ</span></header>
    <Sheet variant="outlined" className="cm-workspace">
      <div className="cm-toolbar"><Typography level="title-sm">Файлы события</Typography><LockRounded color="disabled"/></div>
      <div className="cm-content"><div className="cm-files is-grid">{[1, 2, 3].map(id =>
        <Sheet key={id} variant="outlined" sx={{borderRadius: '12px', overflow: 'hidden'}}>
          <Stack alignItems="center" justifyContent="center" sx={{height: 118, bgcolor: 'primary.50', color: 'primary.300'}}><FolderRounded sx={{fontSize: 44}}/></Stack>
          <Box sx={{p: 2}}><Skeleton variant="text" width="70%" animation={false}/><Skeleton variant="text" width="40%" animation={false}/></Box>
        </Sheet>)}</div></div>
    </Sheet>
  </Box>;
}

export default function MaterialsAccessPage({audience = 'guest'}) {
  const {account, logout} = useContext(LayoutContext);
  const ready = Boolean(account) && !needsClientProfile(account);
  const token = ready ? localStorage.getItem('client_token') || '' : '';
  return <Box data-track-ignore>
    {ready && token
      ? <HomeMediaFolder key={`${audience}:${account.id}:${token}`} audience={audience} signedIn getToken={() => token}
          onSessionExpired={logout}/>
      : <LockedMaterials/>}
    <AuthModal open={!ready || !token} onClose={() => {}} required purpose="materials"/>
  </Box>;
}
